<template>
    <div class="test">
        <video ref="myref" src="https://ubiquity.tv/backend/media/pages/directors/audrey-mascina/lancome-idoles/2702929876-1599891895/2.-lancome-idoles-audrey-mascina.mp4"></video>
    </div>
</template>

<script>

// Utils
import params from '../../utils/params'
import MyEmitter from '../../helpers/MyEmitter'

// Scene
import Scene404 from '../../helpers/threejs/scenes/Scene404'


export default {
    components: {
    },
    name: "Test",
        mounted: function(){

        // wait ressources
        MyEmitter.emit(params.Events.appHasLoadedRessources)


        console.log("video", this.$refs.myref)

    }

}
</script>

<style lang="scss">
    .test{
        border: 4px solid red;
        
        video{
            border: 4px solid blue;
            width: 100%
        }
    }
</style>